/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { FilePlanEntry } from '../model/filePlanEntry';
import { RecordCategoryEntry } from '../model/recordCategoryEntry';
import { RecordCategoryPaging } from '../model/recordCategoryPaging';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class FilePlansApi extends BaseApi {
    createFilePlanCategories(filePlanId, nodeBodyCreate, opts) {
        throwIfNotDefined(filePlanId, 'filePlanId');
        throwIfNotDefined(nodeBodyCreate, 'nodeBodyCreate');
        const pathParams = {
            filePlanId
        };
        const queryParams = {
            autoRename: opts === null || opts === void 0 ? void 0 : opts.autoRename,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/file-plans/{filePlanId}/categories',
            pathParams,
            queryParams,
            contentTypes: ['application/json', 'multipart/form-data'],
            bodyParam: nodeBodyCreate,
            returnType: RecordCategoryEntry
        });
    }
    getFilePlan(filePlanId, opts) {
        throwIfNotDefined(filePlanId, 'filePlanId');
        const pathParams = {
            filePlanId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/file-plans/{filePlanId}',
            pathParams,
            queryParams,
            returnType: FilePlanEntry
        });
    }
    getFilePlanCategories(filePlanId, opts) {
        throwIfNotDefined(filePlanId, 'filePlanId');
        const pathParams = {
            filePlanId
        };
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            includeSource: opts === null || opts === void 0 ? void 0 : opts.includeSource,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/file-plans/{filePlanId}/categories',
            pathParams,
            queryParams,
            returnType: RecordCategoryPaging
        });
    }
    updateFilePlan(filePlanId, filePlanBodyUpdate, opts) {
        throwIfNotDefined(filePlanId, 'filePlanId');
        throwIfNotDefined(filePlanBodyUpdate, 'filePlanBodyUpdate');
        const pathParams = {
            filePlanId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/file-plans/{filePlanId}',
            pathParams,
            queryParams,
            bodyParam: filePlanBodyUpdate,
            returnType: FilePlanEntry
        });
    }
}
